<template>
  <div class="contact-container">
    <h2>联系我们</h2>
    <div class="contact-info">
      <div class="item"><span>电子邮件：</span><span>worldliterature@shisu.edu.cn</span></div>
      <div class="item"><span>来访地址：</span><span>上海外国语大学松江校区文翔路1550号 小别墅21号</span></div>
      <div class="item">
        <span>友情链接：</span>
        <div class="link">
          <a href="https://www.shisu.edu.cn/" target="_blank">上海外国语大学官网</a>
          <a href="http://www.saggas.shisu.edu.cn/" target="_blank">上海全球治理与区域国别研究院官网</a>
        </div>
      </div>
    </div>
    <el-image :src="require('@/assets/images/contact_img.png')" fit="contain"></el-image>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {

  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.contact-container {
  h2 {
    font-weight: 600;
    font-size: 28px;
    line-height: 45px;
    text-align: center;
    color: #212529;
    margin-bottom: 30px;
  }
  .contact-info {
    margin-bottom: 30px;
    .item {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      font-size: 18px;
      font-weight: 600;
      span {
        line-height: 40px;
        color: #333;
      }
      .link {
        a {
          display: block;
          line-height: 40px;
          font-size: 18px;
          color: #333;
          font-weight: 600;
          text-decoration: underline;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .contact-container {
    .contact-info {
      margin-bottom: 20px;
      .item {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 8px;
        span {
          line-height: normal;
          color: #333;
        }
        > span:first-child {
          width: 82px;
        }
        > span:last-child {
          flex: 1;
        }
        .link {
          a {
            display: block;
            line-height: normal;
            font-size: 14px;
            color: #333;
            font-weight: 500;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>